<lib-site-setup-navbar
  [stepNumber]="StepNumberEnum.PracticeManager"
  class="w-full"
  [loggedInUser]="vm().currentUser"
  [hasBackButton]="false"
></lib-site-setup-navbar>
<div class="flex max-w-[800px] flex-col items-center">
  <h1 class="typo-h1 mt-10 whitespace-pre-wrap text-center font-semibold">{{ 'site_install_practice_management_title' | translate }}</h1>
  <div class="mt-10 flex flex-col items-center xs:mt-22 xs:flex-row">
    <div>
      <h4 class="typo-h4-semibold mb-8">{{ 'site_install_practice_management_subtitle' | translate }}</h4>
      <span class="typo-h4-light">{{ 'site_install_practice_management_description' | translate }}</span>
      <button
        class="btn-primary-big mt-8 w-full justify-center xs:w-auto"
        [routerLink]="'/' + routes.siteAdminPracticeUserManagement(vm().contract?.data?.siteId ?? '')"
        [queryParams]="{
          fromInstaller: true
        }"
      >
        {{ 'site_install_practice_management_button' | translate }}
      </button>
    </div>

    <img src="/assets/images/practice-manager-illustration.png" class="mt-6 w-full max-w-[320px] xs:-mr-20 xs:mt-0 xs:w-[465px] xs:max-w-none" />
  </div>
</div>
